module.exports = __webpack_public_path__ + "static/media/refurbishGardenFenceAndSlabs.b9264d75.jpg";